module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-divider', [_vm._v("单位信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "赛季",
      "value": _vm.pageData.sjname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "赛区",
      "value": _vm.pageData.sqname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.pageData.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍名称",
      "value": _vm.pageData.mingcheng
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "食宿服务",
      "value": _vm.pageData.need_shisu == 1 ? '是' : '否'
    }
  })], 1), _vm._v(" "), (_vm.pageData.need_shisu == 1) ? _c('div', [_c('van-divider', [_vm._v("数量信息")]), _vm._v(" "), (_vm.pageData.room_list) ? _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "总人数",
      "label": _vm.pageData.m_member_count + '男' + _vm.pageData.f_member_count + '女',
      "value": _vm.pageData.total_member_count
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "房间数"
    }
  }, [_vm._v("\n                总计" + _vm._s(_vm.pageData.room_list.length) + "间\n                "), _vm._l((_vm.pageData.room_types), function(count, type) {
    return _c('div', [_vm._v(_vm._s(type) + " x " + _vm._s(count))])
  })], 2), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "特殊要求",
      "value": _vm.pageData.shisudes
    }
  })], 1) : _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("用户信息未提交")]), _vm._v(" "), _c('van-divider', [_vm._v("酒店信息")]), _vm._v(" "), (_vm.pageData.hotel) ? _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "酒店名称",
      "value": _vm.pageData.hotel.name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "地址",
      "value": _vm.pageData.hotel.address
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sub-title",
    staticStyle: {
      "color": "#999",
      "text-align": "center"
    }
  }, [_vm._v("等待更新")]), _vm._v(" "), _c('van-divider', [_vm._v("交通信息")]), _vm._v(" "), (_vm.pageData.bus_list.length > 0) ? _c('van-cell-group', _vm._l((_vm.pageData.bus_list), function(bus, index) {
    return _c('van-cell', {
      attrs: {
        "title": bus.name
      }
    })
  }), 1) : _c('div', {
    staticClass: "sub-title",
    staticStyle: {
      "color": "#999",
      "text-align": "center"
    }
  }, [_vm._v("等待更新")]), _vm._v(" "), _c('van-divider', [_vm._v("房间信息")]), _vm._v(" "), (_vm.pageData.room_list) ? _c('van-cell-group', _vm._l((_vm.pageData.room_list), function(room, index) {
    return _c('van-cell', {
      attrs: {
        "title": (index + 1) + '.' + room.name
      }
    }, _vm._l((room.member), function(user) {
      return _c('div', [_vm._v(_vm._s(user.name) + "(" + _vm._s(_vm._f("userType")(user.type)) + ")")])
    }), 0)
  }), 1) : _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("用户信息未提交")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [(_vm.pageData.confirm_3 == 2) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_vm._v("信息无误 我已确认")]) : _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "plain": ""
    }
  }, [_vm._v("信息已确认")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.edit($event)
      }
    }
  }, [_vm._v("信息需要修改")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goIndex($event)
      }
    }
  }, [_vm._v("返回首页")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-147b864b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/saiConfirmDetail3.vue
// module id = 1151
// module chunks = 0